/**
 * EbenezerLogo — uses the Gemini-illustrated SVG logo.
 *
 * Controlled by HEIGHT (not width) because the cropped viewBox is landscape
 * (~1.4:1) — a fixed height fills the navbar properly and lets width scale.
 *
 * Light : original warm-brown illustration on transparent bg
 * Dark  : invert(1) + hue-rotate(180°) flips brown → amber, cream → near-black
 */

import React from "react";

export default function EbenezerLogo({ height = 54, theme = "light", style = {}, className = "" }) {
  const isDark = theme === "dark";

  return (
    <img
      src="/logo.svg"
      alt="Ebenezer Books"
      className={className}
      style={{
        display: "block",
        flexShrink: 0,
        height: height,
        width: "auto",           /* width scales from viewBox aspect ratio */
        objectFit: "contain",
        filter: isDark
          ? "invert(1) hue-rotate(180deg) brightness(0.92) saturate(1.2)"
          : "none",
        transition: "filter 0.3s ease",
        ...style,
      }}
    />
  );
}
